import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "../axios-orders";
import { ApprovalRule, ApprovalRuleInput } from "../types";
import { queryKeys } from "./queryKeys";

/** The company's approval tiers (`GET`, MANAGE_PURCHASE_ORDER_APPROVALS + OC module). */
export const useApprovalRules = () =>
  useQuery<ApprovalRule[]>({
    queryKey: [queryKeys.PURCHASE_ORDER_APPROVAL_RULES],
    queryFn: async () => {
      const { data } = await axios.get("/purchase-orders/approval-rules");
      return data;
    },
  });

/**
 * `PUT` with REPLACE semantics: the body is the FULL desired set of the company's tiers (anything
 * omitted is deleted server-side; `[]` clears every rule). A 400 means a duplicate
 * (currency, minAmount) or a foreign approver.
 */
export const useReplaceApprovalRules = () => {
  const queryClient = useQueryClient();
  return useMutation<ApprovalRule[], Error, ApprovalRuleInput[]>({
    mutationFn: async (rules) => {
      const { data } = await axios.put(
        "/purchase-orders/approval-rules",
        rules
      );
      return data;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [queryKeys.PURCHASE_ORDER_APPROVAL_RULES],
      }),
  });
};
